<template>
  <transition name="modal-fade">
    <div
      v-if="!modal || expanded || desktop"
      class="site-select"
      :class="{ expanded: visible, in_search_state: inSearchPage }"
      v-click-outside="onClickOutside"
    >
      <div v-click-outside="hideSuggestions">
        <template v-if="mobile">
          <i v-if="visible" class="icon icon-close-black" @click="collapse"></i>
          <div v-if="!visible" class="site-select-search">
            <input
              id="mobile-where-surf"
              ref="input"
              type="text"
              :placeholder="rootInputText"
              @focus="onInputFocus"
              v-model="query"
            />
            <i class="icon icon-search"></i>
          </div>
        </template>
        <template v-else>
          <i v-if="visible" class="icon icon-close-black" @click="collapse"></i>
          <div v-if="!visible" class="site-select-search">
            <input
              ref="input"
              type="text"
              :placeholder="rootInputText"
              @focus="onInputFocus"
              v-model="query"
            />
            <i class="icon icon-chevron-down-black" @click="focusInput"></i>
            <button>
              <i class="icon icon-search-white"></i>
            </button>
          </div>
        </template>
        <!--<transition name="fade">-->
        <!--<suggesting-component v-show="suggesting && ! mobile && ! visible" :loading="sites.loading"-->
        <!--:suggesting="suggesting"-->
        <!--:suggestions="suggestions"-->
        <!--@click="hideSuggestions()"-->
        <!--:query="query"></suggesting-component>-->
        <!--</transition>-->
      </div>
      <div v-if="visible" class="site-select-search-options">
        <div
          class="search-options"
          v-if="(!option.hide_desktop && !mobile) || mobile"
          v-for="(option, idx) in computedSearchOptions"
        >
          <div class="search-option">
            <div
              class="search-option-head"
              :class="{ open: open_search_option === idx }"
              @click="toggleSearchBody(option, idx)"
            >
              <span
                class="option-head-icon"
                :style="{ backgroundImage: 'url(' + $icons[option.icon] + ')' }"
              ></span>
              <span class="option-head-title">{{ option.title }}</span>
              <span
                class="option-head-toggle"
                v-if="mobile"
                :class="{ open: open_search_option === idx }"
              ></span>
            </div>
            <transition name="slide">
              <div
                class="search-option-body"
                v-if="
                  !mobile || (option.component && open_search_option === idx)
                "
              >
                <template v-if="option.component === 'SiteCountrySearch'">
                  <div class="search-body-countries">
                    <div class="site-select-search force-mobile">
                      <input
                        ref="input"
                        type="text"
                        :placeholder="$t('איפה בא לך לגלוש?')"
                        @focus="onInputFocus"
                        @blur="suggesting = false"
                        v-model="query"
                      />
                      <i class="icon icon-search"></i>
                    </div>

                    <transition name="fade">
                      <suggesting-component
                        v-if="suggesting"
                        :loading="sites.loading"
                        :suggesting="suggesting"
                        :suggestions="suggestions"
                        @click="hideSuggestions"
                        :query="query"
                      >
                      </suggesting-component>
                    </transition>

                    <h3>{{ siteData.all_countries_and_sites_title }}</h3>

                    <div v-if="sites.loading" class="center">
                      <div class="lds-ellipsis">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>

                    <div class="site-select-country-list">
                      <div
                        v-for="country in countries"
                        :key="country.name"
                        :class="{
                          'site-select-country': true,
                          active: selectedCountry == country.name
                        }"
                        @click="onCountryClick(country.name)"
                      >
                        <div class="site-select-country-title">
                          {{ country.name }}
                          <i class="icon icon-chevron-down-black"></i>
                        </div>
                        <transition name="fade">
                          <ul v-if="selectedCountry === country.name">
                            <template v-for="(site, j) in country.sites">
                              <li v-if="site.show_in_menus" :key="j">
                                <a :href="site.url">
                                  <h4>{{ site.title }}</h4>
                                  <div v-if="site.price[0]" class="price">
                                    <i v-if="site.price[2]">{{ $t("מ") }}</i>
                                    <span
                                      v-html="
                                        site.price[0] +
                                          '<small>' +
                                          (site.price[1] || '€') +
                                          '</small>'
                                      "
                                    ></span>
                                  </div>
                                </a>
                              </li>
                            </template>
                          </ul>
                        </transition>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-if="option.component === 'PackageCustomSearch'">
                  <div class="package-custom-search">
                    <form
                      id="custom_form"
                      :action="siteData.vacation_plan"
                      method="post"
                    >
                      <input
                        type="hidden"
                        name="budget"
                        v-model="customSearchData.budget"
                      />
                      <input
                        type="hidden"
                        name="sites"
                        v-model="customSearchData.sites"
                      />
                      <input
                        type="hidden"
                        name="all_selected"
                        v-model="customSearchData.all_selected"
                      />
                      <input
                        type="hidden"
                        name="date"
                        v-model="customDateForm"
                      />
                      <input
                        type="hidden"
                        name="types"
                        v-model="customTypesForm"
                      />
                      <input type="hidden" name="custom" value="1" />
                    </form>

                    <div v-if="sites.loading" class="center">
                      <div class="lds-ellipsis">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                    <template v-else>
                      <div
                        @click="togglePackageSearchSites()"
                        :class="{ 'desktop-active': packageSitesDesktopActive }"
                        class="toggle-package-search-sites"
                      >
                        <span class="icon"></span>
                        <span class="text">{{ $t("בחירת אתר סקי") }}</span>
                      </div>
                      <div
                        class="package-search-sites"
                        :class="{ 'desktop-active': packageSitesDesktopActive }"
                      >
                        <div class="search-site">
                          <div
                            class="search-site-item all-sites"
                            :class="{ selected: customSearchData.all_selected }"
                            @click="customSelectSite(false, true)"
                          >
                            {{ $t("כל האתרים") }}
                          </div>
                        </div>
                        <div v-for="site in sitesInFilter" class="search-site">
                          <div
                            class="search-site-item"
                            :class="{ selected: hasCustomSite(site.id) }"
                            @click="customSelectSite(site)"
                          >
                            <span>{{ site.title }}</span>
                            <span>{{ site.country }}</span>
                          </div>
                        </div>
                      </div>
                      <div
                        @click="togglePackageSearchDate()"
                        :class="{ 'desktop-active': packageDateDesktopActive }"
                        class="toggle-package-search-date"
                      >
                        <span class="icon"></span>
                        <span class="text">
                          <template v-if="!customSearchData.date">{{
                            $t("בחרו תאריך")
                          }}</template>
                          <template v-if="customSearchData.date">
                            {{
                              moment(customSearchData.date["start"]).format(
                                "DD-MM-YYYY"
                              )
                            }}
                            -
                            {{
                              moment(customSearchData.date["end"]).format(
                                "DD-MM-YYYY"
                              )
                            }}
                          </template>
                        </span>
                      </div>
                      <div
                        class="search-site-date"
                        :class="{ 'desktop-active': packageDateDesktopActive }"
                      >
                        <v-date-picker
                          :input-props="{
                            placeholder: $t('בחרו תאריך'),
                            readonly: true
                          }"
                          :min-date="new Date().setMonth(11)"
                          v-model="customSearchData.date"
                          locale="he"
                          :is-inline="!mobile"
                          title-position="left"
                          mode="range"
                        ></v-date-picker>
                      </div>
                      <div class="search-site-type">
                        <div
                          class="search-type"
                          @click="toggleCustomType('week')"
                          :class="{ selected: customSearchData.types.week }"
                        >
                          {{ $t("חופשה של שבוע") }}
                        </div>
                        <div
                          class="search-type"
                          @click="toggleCustomType('weekend')"
                          :class="{ selected: customSearchData.types.weekend }"
                        >
                          {{ $t('חופשה בסופ"ש') }}
                        </div>
                        <div
                          class="search-type"
                          @click="toggleCustomType('weekday')"
                          :class="{ selected: customSearchData.types.weekday }"
                        >
                          {{ $t('חופשה באמצ"ש') }}
                        </div>
                      </div>

                      <div class="search-site-budget">
                        <div class="budget-head">
                          <div class="budget-title">{{ $t("תקציב:") }}</div>
                          <!--<div class="budget-values">-->
                          <!--<span>€</span> {{budgetLocale(0)}}-{{budgetLocale(1)}}-->
                          <!--</div>-->
                        </div>
                        <BudgetSlider
                          :value="customSearchData.budget"
                          @input="onBudgetInput"
                        />
                      </div>

                      <div class="search-site-submit">
                        <button @click="submitCustomSearch" type="button">
                          <template v-if="customSearchData.loading">
                            <div class="lds-ellipsis">
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                            </div>
                          </template>
                          <span v-if="!customSearchData.loading">{{
                            $t("חפש")
                          }}</span>
                        </button>
                      </div>
                    </template>

                    <div class="search-site-custom">
                      <a
                        :href="siteData.vacation_plan"
                        class="site-custom-body"
                      >
                        <div
                          class="custom-body-icon"
                          :style="{
                            backgroundImage:
                              'url(' + $icons['search-site-ski'] + ')'
                          }"
                        ></div>
                        <div class="custom-body-title">
                          {{ $t("מצאו לי אתר סקי מתאים") }}
                        </div>
                        <div class="custom-body-toggle"></div>
                      </a>
                    </div>
                  </div>
                </template>
              </div>
            </transition>
          </div>
        </div>
      </div>
      <!-- <div v-if="mobile && visible" class="site-select-countries">
        <h3>{{ siteData.featured_packages_title }}</h3>
        <div ref="slider" class="site-select-slider"></div>
      </div> -->
    </div>
  </transition>
</template>

<script>
import { $t } from "../i18n";
import { api } from "../API";
import vClickOutside from "v-click-outside";
import { BREAKPOINT_TABLET, BREAKPOINT_DESKTOP } from "../main";
import GenericSlider from "../components/GenericSlider";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
import BudgetSlider from "./BudgetSlider.vue";
import moment from "moment";

const suggestingComponent = {
  props: ["suggesting", "loading", "suggestions", "query"],
  template: `
         <div class="site-select-options">
            <div class="site-select-options-scroll custom-scrollbar">
              <div v-if="loading" class="center">
                <div class="lds-ellipsis">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
              <div
                      v-else-if="suggestions.length === 0 && query != ''"
                      class="site-select-option site-select-no-results"
              >לא נמצא אתר מתאים.</div>
              <template v-else>
                <a
                        class="site-select-option"
                        v-for="suggestion in suggestions"
                        :key="suggestion.url"
                        :href="suggestion.url"
                        @click="onClickSite()"
                >{{ suggestion.title }}, {{ suggestion.country }}</a>
              </template>
            </div>
          </div>
    `,
  methods: {
    onClickSite() {
      this.$emit("click");
    }
  }
};

export default {
  components: { suggestingComponent, VueSlider, BudgetSlider },
  props: {
    expanded: {
      type: Boolean,
      default: false
    },
    desktop: {
      type: Boolean,
      default: false
    },
    modal: {
      type: Boolean,
      default: false
    },
    fixedmodal: {
      type: Boolean,
      default: false
    },
    fromMenu: {
      type: Boolean,
      default: false
    },
    sites: {
      type: Object,
      default: {
        loaded: false,
        loading: false,
        data: []
      }
    },
    rootInputText: {
      type: String,
      default: $t("איפה בא לך לגלוש")
    },
    inSearchPage: {
      type: Boolean,
      default: false
    }
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  data() {
    return {
      moment: moment,

      siteData: window.siteData,

      windowInnerWidth: window.innerWidth,

      // Mobile only.
      selectedCountry: null,

      // Whether suggestions should be shown below the input.
      suggesting: false,

      packageSitesDesktopActive: false,
      packageDateDesktopActive: false,

      query: "",

      customSearchData: {
        loading: false,
        sites: [],
        all_selected: true,
        date: null,
        types: {
          week: true,
          weekend: true,
          weekday: true
        },
        budget: [400, 2000]
      },

      open_search_option: 0,

      mobile_search_options: [
        {
          icon: "search-site-icon",
          title: this.$t("חיפוש לפי מדינה ואתר"),
          component: "SiteCountrySearch"
        },
        {
          icon: "search-site-calendar",
          title: this.$t("חיפוש לפי מסננים"),
          component: "PackageCustomSearch"
        },
        {
          icon: "search-site-ski",
          title: this.$t("לחופשה בהתאמה אישית"),
          url: window.siteData.vacation_plan,
          hide_desktop: true
        }
      ]
    };
  },
  created() {
    window.addEventListener("resize", this.onWindowResize);

    window.eventBus.$on("toggle-select", () => {
      this.onInputFocus();
    });
  },
  destroyed() {
    window.removeEventListener("resize", this.onWindowResize);

    if (this.expanded) {
      // Restore document scrolling.
      $("body").css("overflow", "initial");
    }
  },
  methods: {
    togglePackageSearchSites() {
      this.packageSitesDesktopActive = !this.packageSitesDesktopActive;

      if (this.packageSitesDesktopActive && this.packageDateDesktopActive) {
        this.packageDateDesktopActive = false;
      }
    },
    togglePackageSearchDate() {
      this.packageDateDesktopActive = !this.packageDateDesktopActive;

      if (this.packageDateDesktopActive && this.packageSitesDesktopActive) {
        this.packageSitesDesktopActive = false;
      }
    },
    submitCustomSearch() {
      if (this.customSearchData.loading) {
        return;
      }

      const form = document.getElementById("custom_form");

      this.customSearchData.loading = true;

      form.submit();
    },
    toggleCustomType(type) {
      this.customSearchData.types[type] = !this.customSearchData.types[type];
    },
    customSelectSite(site, all = false, forceAll = false) {
      if (all) {
        this.customSearchData.all_selected =
          forceAll || !this.customSearchData.all_selected;

        if (this.customSearchData.all_selected) {
          this.customSearchData.sites = [...this.site_ids];
        } else {
          this.customSearchData.sites = [];
        }
        return;
      }

      if (site) {
        if (this.customSearchData.sites.indexOf(site.id) !== -1) {
          if (this.customSearchData.all_selected) {
            this.customSearchData.all_selected = false;
          }

          this.customSearchData.sites.splice(
            this.customSearchData.sites.indexOf(site.id),
            1
          );
        } else {
          this.customSearchData.sites.push(site.id);
        }
      }
    },
    hasCustomSite(id) {
      return this.customSearchData.sites.indexOf(id) !== -1;
    },
    toggleSearchBody(option, idx) {
      if (option.url) {
        window.location.href = option.url;
        return;
      }

      if (!this.mobile) {
        return;
      }

      if (idx === this.open_search_option) {
        this.open_search_option = null;
        return;
      }

      if (idx === 1) {
        this.customSelectSite(false, true, true);
      }

      this.open_search_option = idx;
    },
    onWindowResize() {
      this.windowInnerWidth = window.innerWidth;
    },
    fetchSites() {
      if (!this.sites.loaded && !this.sites.loading) {
        this.$emit("load", {
          loading: false,
          loaded: true,
          data: []
        });

        api.sites().then(sites => {
          if (sites) {
            let countries = sites;
            this.sites.data = countries;
            // this.$emit("load", {
            //   loading: true,
            //   loaded: false,
            //   data: []
            // });
          }
        });

        if (!this.mobile) {
          this.customSelectSite(false, true, true);
        }
      }
    },
    expand() {
      // Disable document scrolling.
      if (this.mobile) {
        $("body").css("overflow", "hidden");
      }

      if (this.fromMenu) {
        $(".site-drawer").removeClass("active");
        setTimeout(() => $(".site-drawer").hide(), 500);
      }

      this.$emit("expand");

      this.fetchSites();

      this.$nextTick(() => {
        setTimeout(() => {
          if (this.fixedmodal) {
            $("#site-select-modal .site-select").addClass("fixed");
          }
          let inputs = this.$refs.input;
          if (inputs) {
            if (!Array.isArray(inputs)) {
              inputs = [inputs];
            }

            inputs.forEach(input => input.blur());
          }
        }, 100);
      });
    },
    collapse() {
      if (this.expanded) {
        $("body").css("overflow", "initial");
      }

      this.$emit("collapse");
    },
    showSuggestions() {
      this.suggesting = true;

      this.fetchSites();
    },
    hideSuggestions() {
      if (!this.visible) {
        this.suggesting = false;
      }
    },
    focusInput() {
      if (this.suggesting) {
        this.hideSuggestions();
        this.$refs.input.blur();
      } else {
        this.$refs.input.focus();
      }
    },
    onCountryClick(country) {
      this.selectedCountry = this.selectedCountry === country ? null : country;
    },
    onClickOutside() {
      this.hideSuggestions();

      if (this.mobile) {
        this.collapse();
      }
    },
    onInputFocus() {
      if (this.visible) {
        this.showSuggestions();
      } else {
        this.expand();
      }
    },

    initSlider() {
      // if (! document.querySelector(".generic-slider-hotels")) {
      //   return;
      // }
      //
      // const html = document.querySelector(".generic-slider-hotels").outerHTML;
      //
      // if (! this.$refs.slider) {
      //   return;
      // }
      //
      // this.$refs.slider.innerHTML = html;
      //
      // new GenericSlider($(this.$refs.slider).find(".generic-slider"));
    },

    onBudgetInput(value) {
      this.customSearchData.budget = value;
    }
  },
  computed: {
    customTypesForm() {
      return JSON.stringify(this.customSearchData.types);
    },
    customDateForm() {
      return JSON.stringify(this.customSearchData.date);
    },
    site_ids() {
      if (!this.sites.data) {
        return [];
      }

      let sites = this.sitesInFilter;

      return sites.map(site => {
        return site.id;
      });
    },
    sitesInFilter() {
      if (!this.sites.data) {
        return [];
      }

      return this.sites.data.filter(result => result.show_in_filters);
    },
    suggestions() {
      if (!this.sites.data) {
        return [];
      }

      return this.sites.data.filter(
        result =>
          result.title.toLowerCase().indexOf(this.query.toLowerCase()) === 0 ||
          result.country.toLowerCase().indexOf(this.query.toLowerCase()) === 0
      );
    },

    countries() {
      const countriesMap = {};
      // Group sites by country.
      for (const i in this.sites.data) {
        const site = this.sites.data[i];

        for (const countryIdx in site.countries) {
          if (site.countries[countryIdx] in countriesMap) {
            countriesMap[site.countries[countryIdx]].push(site);
          } else {
            countriesMap[site.countries[countryIdx]] = [site];
          }
        }
      }

      const countries = [];

      for (const name in countriesMap) {
        const siteData = this.sites.data.find(site => site.country === name);

        countries.push({
          name: name,
          sites: countriesMap[name],
          order: this.sites.data.find(site => site.country === name) || 0,
          country_order: siteData ? siteData.country_order : 999
        });
      }

      return countries.sort((a, b) => a.country_order - b.country_order);
    },

    visible() {
      return this.modal && this.expanded;
    },

    mobile() {
      return this.windowInnerWidth < BREAKPOINT_DESKTOP;
    },

    computedSearchOptions() {
      return this.mobile_search_options.filter(
        (option, i) => !this.inSearchPage || i > 0
      );
    }
  },
  watch: {
    "customSearchData.date"(newVal) {
      this.packageDateDesktopActive = false;
    },
    sites(newSites) {
      if (newSites.data.length > 0) {
        this.customSelectSite(false, true, true);
      }
    },

    expanded(now) {
      if (now) {
        this.$nextTick(this.initSlider);
      }
    },

    mobile(now, was) {
      if (now) {
        this.$nextTick(this.initSlider);
      }
    }
  }
};
</script>
